import { createContext, useContext } from 'react';

// Lets the navigation sidebar tell AppLayout it is on screen, so the floating
// support button is only shown on pages that have no sidebar.
export const AppNavContext = createContext({ registerNav: () => () => {} });

export const useAppNav = () => useContext(AppNavContext);
